'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _fetchJsonp = require('fetch-jsonp');

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _araleEvents = require('arale-events');

var _araleEvents2 = _interopRequireDefault(_araleEvents);

var _msccCookie = require('@alife/mscc-cookie');

var _msccCookie2 = _interopRequireDefault(_msccCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by 易晓峰(林异)<yxf@106063@alibaba-inc.com> on 16/5/12.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 统一对异步数据进行处理
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// Ocean 接口变更，配合 native 做修改，当检测到页面 UA 包含 HavanaSession 时，在请求头增加参数
var isHavanaSession = navigator && navigator.userAgent && navigator.userAgent.indexOf('HavanaSession') > -1;
var addHavanaSession = function addHavanaSession(url, options) {
    url = url || '';
    if (isHavanaSession && /^(https?:\/\/)(gateway\.alibaba\.com|gw\.api\.alibaba\.com)/.test(url)) {
        if (options && options.headers instanceof Headers) {
            options.headers.append('havanaSession', 'true');
        } else {
            options = Object.assign({}, options);
            options.headers = Object.assign({}, options.headers, {
                'havanaSession': 'true'
            });
        }
    }
    return options;
};

//错误类

var PorterError = function (_Error) {
    _inherits(PorterError, _Error);

    function PorterError(status, response) {
        _classCallCheck(this, PorterError);

        var _this = _possibleConstructorReturn(this, (PorterError.__proto__ || Object.getPrototypeOf(PorterError)).call(this));

        _this.name = 'FetchError';
        _this.response = response;
        _this.status = status;
        return _this;
    }

    return PorterError;
}(Error);

/**
 * 发送打点的数据
 * @param url
 * @param name
 * @param type
 * @param startTime
 * @param reason
 */


var sendTrack = function sendTrack(url, name, type, startTime, reason) {
    var pattern = /^(https?:)?\/\/(.+)([\?\#].+)$/i;

    if (!name && pattern.test(url)) name = RegExp.$2;
    name = name || url;
    var duration = new Date() - startTime;

    var ext = 'name=' + name + '|type=' + type + '|time=' + duration;
    if (type === 'failure') {
        ext += '|reason=' + reason + '|url=' + url;
    };

    //积木盒子在预览的时候，可能没有dotstat
    window.dmtrack && window.dmtrack.dotstat && window.dmtrack.dotstat(27132, { ext: ext });
};

//确保Query包含?
var ensureQuery = function ensureQuery(url) {
    if (url.indexOf('?') < 0) {
        url += '?1=1';
    };
    return url;
};

//给url添加时间戳
var appendTimestamp = function appendTimestamp(url) {
    url = ensureQuery(url);
    return url + '&_=' + new Date().valueOf();
};

//给url添加ctoken
var appendCToken = function appendCToken(url) {
    var ctoken = _msccCookie2.default.getCToken();
    //没有CToken,直接返回不处理
    if (!ctoken) return url;

    url = ensureQuery(url);
    return url + '&ctoken=' + ctoken;
};

// Ocean 方面称不要直接访问 gw.api.alibaba.com 域名
var changeDomain = function changeDomain(url) {
    return url.replace('gw.api.alibaba.com', 'gateway.alibaba.com');
};

//重新修订URL
var reviseUrl = function reviseUrl(url, options) {
    if (!options.noCache) url = appendTimestamp(url);
    if (options.ctoken !== false) url = appendCToken(url);
    url = changeDomain(url);
    return url;
};

var Porter = {
    //提供给外部用的打点功能
    sendTrack: sendTrack,
    //获取jsonp的数据
    jsonp: function jsonp(url, options) {
        var defaultOptions = {
            //默认60秒钟的时间
            timeout: 1000 * 60
        };

        var startTime = new Date();
        options = Object.assign({}, defaultOptions, options);
        options = addHavanaSession(url, options);
        url = reviseUrl(url, options);
        //发送打点
        // sendTrack(url, options.apiName, 'before', startTime);
        var result = (0, _fetchJsonp2.default)(url, options);

        return receiveData(result, url, options.apiName, startTime);
    },
    //直接处理ajax, 完全自定义
    fetch: function (_fetch) {
        function fetch(_x, _x2) {
            return _fetch.apply(this, arguments);
        }

        fetch.toString = function () {
            return _fetch.toString();
        };

        return fetch;
    }(function (url, options) {
        url = changeDomain(url);
        options = addHavanaSession(url, options);
        return fetch(url, options);
    })
};

//获取数据完成后的操作
var receiveData = function receiveData(result, url, apiName, startTime) {
    return result.then(function (res) {
        if (res.ok) {
            //成功的打点
            sendTrack(url, apiName, 'success', startTime);
            return res.json();
        };

        //失败的打点
        sendTrack(url, apiName, 'failure', startTime, res.status);
        var error = new PorterError(res.status, res);
        Porter.trigger('error', error);
        throw error;
    });
};

//异步获取数据, 数据格式为json, 同时会做异常捕获的处理
var normalFetch = function normalFetch(url, options, startTime) {
    var defaultOptions = {
        method: 'GET',
        //默认情况下, 包含cookies
        credentials: 'same-origin'
    };

    var ops = Object.assign({}, defaultOptions, options);
    ops = addHavanaSession(url, ops);
    //将对象的body转换为string
    if (_typeof(ops.body) === 'object' && !(ops.body instanceof FormData)) {
        ops.body = JSON.stringify(ops.body);
    }

    //url = appendTimestamp(url);
    //开始的打点
    sendTrack(url, options.apiName, 'send', startTime);
    return fetch(url, ops);
};

['put', 'delete', 'post', 'get'].forEach(function (method) {
    Porter[method] = function (url) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        options.method = method;
        url = reviseUrl(url, options);

        var startTime = new Date();
        var result = normalFetch(url, options, startTime);
        return receiveData(result, url, options.apiName, startTime);
    };
});

_araleEvents2.default.mixTo(Porter);

exports.default = Porter;


// WEBPACK FOOTER //
// ./node_modules/@alife/mscc-porter/lib/index.js